export const slugify = (text: string): string => text
  .toString()          // Cast to string (optional)
  .normalize('NFKD')  // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
  .toLowerCase()      // Convert the string to lowercase letters
  .trim()             // Remove whitespace from both sides of a string (optional)
  .replace(/\s+/g, '-')       // Replace spaces with -
  .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
  .replace(/\-\-+/g, '-')     // Replace multiple - with single -


export const parseSearchParams = (searchParams: string): Record<string, string[]> => {
  if(typeof searchParams !== 'string' || searchParams.trim() === '') return {}

  return searchParams.split('&').reduce((acc, param) => {
    const [key, values] = param.split('=')
    if (!key || !values) return acc

    const decodedValues = decodeURIComponent(values).split(',')

    // If key already exists, merge values
    acc[key] = acc[key] ? [...acc[key], ...decodedValues] : decodedValues

    return acc
  }, {} as Record<string, string[]>)
}

/**
 * List of URL search params to exclude from filters processing
 * (e.g., tracking params, common non-filtering params, etc.)
 */
export const URL_TRACKING_PARAMS: string[] = [
  // UTM
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'utm_source_platform',
  'utm_creative_format',
  'utm_marketing_tactic',

  // Google Ads / Marketing Platform
  'gclid',
  'gbraid',
  'wbraid',
  'dclid',
  'gad_source',

  // Meta
  'fbclid',
  'fbc',
  'fbp',

  // Bing
  'msclkid',

  // TikTok
  'ttcid',
  'ttad_id',

  // LinkedIn
  'li_fat_id',

  // Twitter/X
  'twclid',

  // Hotjar / Clarity (rare, but included)
  '_hjincludedinsessionsample',
  '_hjincludedinpageviewsample',
  'clid',

  // Hubspot
  'hsctatracking',
  '_hsenc',
  '_hsmi',

  // Affiliate / Partners
  'aff_id',
  'aff_sub',
  'aff_sub2',
  'ref',
  'refid',
  'pid',
  'cid',
  'clickid',
  'subid',

  // Ecommerce misc
  'promo',
  'promo_code',

  // SEO/technical (just to be safe)
  'page',
  'sort'
]

export const sanitizeFilters = (filters: Record<string, string[]>, customExclusions: string[] = []): Record<string, string[]> => {
  const exclusions = new Set([
    ...URL_TRACKING_PARAMS,
    ...customExclusions
  ].map(param => param.toLowerCase()))

  return Object.entries(filters).reduce((acc, [key, value]) => {
    const normalized = key.toLowerCase()

    if (!exclusions.has(normalized)) acc[key] = value

    return acc
  }, {} as Record<string, string[]>)
}
